import React from 'react';
import "../styles/App.scss";

const DEFAULT_PLAYER = "/images/mcm/soundoff-btn.png";
const ON_PLAYER = "/images/mcm/soundon-btn.png";

function RecordPlayer(props){
    const {soundState, altText} = props
    const imgToUse = soundState ? ON_PLAYER : DEFAULT_PLAYER;

    return(
        <>
            <div className='recordplayer'>
                <img className="recordplayerimg" src={imgToUse} alt={altText}/>
            </div>
        </>
    );
}
export default RecordPlayer;